
<h2 mat-dialog-title>Escolha seu horário</h2>
<mat-dialog-content class="mat-typography">
  <p class="initial-p">
    Veja abaixo os especialistas disponíveis, se preferir, realize filtros no campo abaixo:
  </p>

  <h2 *ngIf="!healthcareservice">Não há especialistas disponíveis no momento</h2>

  <mat-card class="procedure-card">
    <div class="col-sm-12 col-md-6">
      <shedule-organization-dealer 
      [organization]="organization"
      [healthcareservice]="healthcareservice"
      [location]="location">
    </shedule-organization-dealer>
    </div>
    <div class="schedule-wrapper proc col-sm-12 col-md-6" id="schedule-{{ index }}">
      <schedule-organization-hour 
        [healthcareservice]="healthcareservice"
        [organization]="organization"
        [location]="location"
        (onSelectedDatetime)="onSelectedDatetime($event, healthcareservice)">
      </schedule-organization-hour> 
    </div>
  </mat-card>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="primary" [mat-dialog-close]="false">Fechar</button>
</mat-dialog-actions>
